import { CONSTANT } from "src/app/constant";

const FORM_TYPE_SHORT_LABELS: Record<string, string> = {
	[CONSTANT.FORM_TYPE.ts_1]: "eTS-1",
	[CONSTANT.FORM_TYPE.ts_3]: "eTS-3",
	[CONSTANT.FORM_TYPE.ts_5]: "eTS-5",
	[CONSTANT.FORM_TYPE.ts_6]: "eTS-6",
	[CONSTANT.FORM_TYPE.cabin_crew]: "Cabin Crew",
	[CONSTANT.FORM_TYPE.cabin_crew_instructor]: "Cabin Crew Instructor",
};

export function getFormTypeShortLabel(formType?: string): string {
	if (!formType) {
		return "";
	}
	return FORM_TYPE_SHORT_LABELS[formType] ?? formType;
}

/** Submitted report heading. The form name only, with no Preview or Summary prefix. */
export function buildSummaryReportTitle(formType?: string): string {
	return getFormTypeShortLabel(formType);
}

export function buildPreviewSummaryTitle(formType?: string): string {
	const label = getFormTypeShortLabel(formType);
	return label ? `Preview Summary - ${label}` : "Preview Summary";
}
